import { memo, useEffect } from 'react'
import { Template } from '../Template'
import { useKcLanguageTag, kcMessages } from 'keycloakify'
import type { KcProps } from 'keycloakify'
import type { KcContextBase } from 'keycloakify'
import { useKcMessage } from 'keycloakify/lib/i18n/useKcMessage'
import { useCssAndCx } from 'tss-react'
import tos_en_url from './tos.md'
import { Button, Form } from '@xanadu_ai/xanadu-component-library'

export const Terms = memo(
  ({ kcContext, ...props }: { kcContext: KcContextBase.Terms } & KcProps) => {
    const { kcLanguageTag } = useKcLanguageTag()

    useEffect(() => {
      if (kcContext!.pageId !== 'terms.ftl') {
        return
      }

      kcMessages[kcLanguageTag].termsTitle = ''
      fetch((() => tos_en_url)())
        .then((response) => response.text())
        .then(
          (rawMarkdown) => (kcMessages[kcLanguageTag].termsText = rawMarkdown)
        )
      // eslint-disable-next-line
    }, [kcLanguageTag])

    const { msg, msgStr } = useKcMessage()
    const { cx } = useCssAndCx()
    const { url } = kcContext

    return (
      <Template
        {...{ kcContext, ...props }}
        doFetchDefaultThemeResources={false}
        displayMessage={false}
        headerNode={msg('termsTitle')}
        displayWide
        kcFormCardAccountClass="Card--wide"
        formNode={
          <>
            <div
              id="kc-terms-text"
              data-testid="terms-text"
              className="overflow-y-scroll h-96 mt-4"
            >
              {msg('termsText')}
            </div>
            <Form
              formName="tos-form"
              action={url.loginAction}
              method="post"
              onSubmit={(_e: React.SyntheticEvent) => {}}
            >
              <div className="flex mx-auto gap-2 pt-8">
                <a
                  data-testid="decline-terms"
                  className={cx(props.kcButtonDefaultClass)}
                  href={url.loginUrl}
                >
                  {msgStr('doDecline')}
                </a>
                <Button
                  className="justify-center"
                  testId="accept-terms"
                  buttonType="submit"
                  label={msgStr('doAccept')}
                />
              </div>
            </Form>
            <div className="clearfix" />
          </>
        }
      />
    )
  }
)
